import React from "react";
import "./ClientsLogo.css";
import clientLogos from "../../data/logos.png";

// import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

// import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore, { Autoplay } from "swiper";

// Import Swiper styles
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/scrollbar";
// import homeClientLogo from "../../data/homeClientLogo";

// SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const ClientsLogo = () => {
  return (
    <div className="py-10 bg-[#d6d6d6] ">
      <div className="container mx-auto">
        <h1 className="text-[35px] lg:text-[50px] mb-[50px] text-center font-bold leading-10 text-[#002060]">
          Clients & Associates
        </h1>

        <div className="container mx-auto -mt-[100px]">
          <img
            src={clientLogos}
            alt="All Client Logos"
            className="clientBlock"
          />
        </div>
      </div>
    </div>
  );
};

export default ClientsLogo;
